import { CreditFormConfiguration } from "./CreditFormConfiguration";

export class CreditFormPageApplication {
    private currentContainer: JQuery;
    private configuration: CreditFormConfiguration;
    private forceFormSubmit: JQuery;
    private loading: JQuery;

    constructor(private container: JQuery) {
        this.currentContainer = container;
        this.configuration = new CreditFormConfiguration(container);
        this.forceFormSubmit = $('.force-creation-of-form-submit');
        this.loading = $('.loading');

        this.initialize();
    }

    setLoading(active: boolean) {
        if (active) {
            this.loading.addClass('show');
        } else {
            this.loading.removeClass('show');
        }        
    }

    createOrganization(){
        let application = this;
        this.setLoading(true);
        $.ajax({
            url: this.configuration.creatUrl + this.configuration.formGuid,
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                application.setLoading(false);
                if (data === '00000000-0000-0000-0000-000000000000') {
                    location.reload();
                } else {
                    window.location.href = application.configuration.organizationUrl + data;
                }                
            },
            error: function (data) {
                application.setLoading(false);
                const json = data.responseJSON;
                let message = json.Message;
                if (!message) {
                    message = `${json.status} ${json.title}`;
                }
            }
        });
    }

    private initialize() {
        this.forceFormSubmit.on('click', () => this.createOrganization());
    }
}